class CommonApiError extends Error {
    constructor(
    public readonly body: unknown,
    message?: string
    ) {
        super(message || 'Common Api Error')
        this.name = 'CommonApiError'
    }
}

export default CommonApiError
